import axios from './factory'
import { urlFormat, formFormat } from './content-type'
import Vue from 'vue'
import { Loading } from 'element-ui'
import { NeedLoginStatus } from './code'
import { getOauth2AccessToken } from '@/util/extends/cookieExpand'
//引入增强js
import '@/util/extends/toFirstUpperCase'
import { storeApi } from '@/api/store'

//没有api的配置链接加上static,自动分类
//这叫api树
class ApiConfig {
  constructor() {
    this.methods = ['get', 'post', 'put', 'delete', 'patch']
    this.api = {}
    this.flag = true
    this.lastUrl = null
    this.api.system = {
      validateCode: {
        server: process.env.VUE_APP_BASE_PATH + 'servlet/validateCodeServlet',
        static: true,
      }, //验证码链接
      login: { server: 'api/ucenter/user/userLogin.do' }, //登录
      // logout: { server: "api/ucenter/user/userLogout.do"}, //退出
      oauthLogout: {
        server: 'oauth/logout',
        method: 'get',
        baseUrl: process.env.VUE_APP_BASE_PATH,
      }, //退出
      // logout: { mock: "/login", server: process.env.VUE_APP_BASE_PATH + process.env.API_PATH + "logout.do", static:true },
      logList: { server: 'api/ucenter/log/list.json', method: 'get' }, //系统日志列表
      region: { server: 'api/ucenter/region/getAllRegionListToTree.json', method: 'get' }, //区域
      getRegionConfigureVoListByName: {
        server: 'api/ucenter/region/getRegionConfigureVoListByName.json',
        method: 'get',
      }, //区域（参数regionName）
      brandTree: {
        server: 'api/ucenter/brandCategory/getAllBrandOrCategoryListToTree.json',
        method: 'get',
      }, //品牌品类树
      allByTree: { server: 'api/ucenter/position/listAllByTree.json', method: 'get' }, //职位树
    }
    this.api.synchrodata = {
      oaBegin: { server: '/ucenter/synchroWithOA/getSynchroWithOA.json', method: 'get' }, //数据同步开始
      mtdsBegin: { server: '/ucenter/synchroWithMTDS/getSynchroWithMTDS.json', method: 'get' }, //数据同步开始
      mtdsProgress: {
        server: '/ucenter/synchroWithMTDS/getProgressBarParameterWithMTDS.json',
        method: 'get',
      }, //数据同步进度
      oaProgress: {
        server: '/ucenter/synchroWithOA/getProgressBarParameterWithOA.json',
        method: 'get',
      }, //数据同步进度
    }
    this.api.department = {
      list: { server: 'api/ucenter/department/list.json', method: 'get' }, //获取全部
      // tree: {mock: "/dept/tree", server: "api/ucenter/department/listAllByTree.json"}, //获取树形
      // tree: { server: "api/ucenter/department/getAllDepartmentConfigureListToTree.json",method:'get'}, //获取部门树形（旧）
      getDepartmentTreeList: {
        server: 'api/ucenter/department/getDepartmentTreeList.json',
        method: 'get',
      }, //获取当前部门树（最新）
      getAccDepartmentTreeList: {
        server: 'api/ucenter/accDepartment/getDepartmentTreeList.json',
        method: 'get',
      }, //获取当前部门树（acc）
      children: { server: 'api/ucenter/department/getSubDepartmentsById.json', method: 'get' }, //获取全部
      getBrand: {
        server: 'api/ucenter/departmentBrand/getBrandListToDepartment.json',
        method: 'get',
      }, //获取部门已配置的品牌品类
      getAllBrand: {
        server: 'api/ucenter/departmentBrand/getBrandConfigureListToDepartment.json',
        method: 'get',
      }, //获取部门可配置的品牌品类 传1是全部数据
      setBrand: { server: 'api/ucenter/departmentBrand/editDepartmentToBrandList.json' }, //获取部门的品牌品类
      getProductChannelListToDepartment: {
        server: 'api/ucenter/department/productChannel/get',
        method: 'get',
      }, // 获取部门产品渠道列表
      modifyProductChannelListToDepartment: {
        server: 'api/ucenter/department/productChannel/modify',
        method: 'post',
      }, // 修改部门产品渠道列表
      getRegion: {
        server: 'api/ucenter/departmentRegion/getRegionListToDepartment.json',
        method: 'get',
      }, //获取部门的品牌品类
      setRegion: { server: 'api/ucenter/departmentRegion/editDepartmentToRegionList.json' }, //编辑部门经营区域
      saveDept: { server: 'api/ucenter/department/addDepartment.json' }, // 新增第三方部门
      selectDept: { server: 'api/ucenter/department/getDepartment.json', method: 'get' }, // 查询第三方部门信息
      updateDept: { server: 'api/ucenter/department/updateDepartment.json' }, // 修改第三方部门
      deleteDept: { server: 'api/ucenter/department/softDeleteDepartment.json' }, // 删除第三方部门

      // deparList: { server: "api/ucenter/userManageDepartment/getManageDepartmentListToUser.json",method:'get'}, //根据用户ID获取管理部门列表 。。。。。。
      updateDepar: {
        server: 'api/ucenter/userManageDepartment/updateManageDepartmentsToUser.json',
      }, //为指定用户添加多个管理部门
      // checkMarketAdmin: {server: "api/ucenter/userConfigure/checkUserMarketAdminToMarketList.json"}, //检测商场/部门是否存在
      getLineDepartmentExtendPageList: {
        server: 'api/ucenter/departmentExtend/getLineDepartmentExtendPageList.json',
        method: 'get',
      }, //根据线别ID获取商场列表（分页）
      getLineDepartmentExtendConfigureList: {
        server: 'api/ucenter/userConfigure/getMarketConfigureListToUser.json',
        method: 'get',
      }, //根据线别ID获取商场列表（分页）
      getDepartmentByUserId: {
        server: 'api/ucenter/department/getDepartmentByUserId.json',
        method: 'get',
      }, //根据用户ID获取部门列表

      getLineInfoTreeList: { server: 'api/ucenter/line/getLineInfoTreeList', method: 'get' }, //根据参数获取筛选线别

      getPidDepartmentList: {
        server: 'api/ucenter/department/getPidDepartmentList.json',
        method: 'get',
      }, //根据部门PID获取下级部门列表
      getDepartmentListByIds: {
        server: 'api/ucenter/department/getDepartmentListByIds.json',
        method: 'get',
      }, //根据部门ID串获取多个部门信息

      getCacheRegion: { baseUrl: '/', server: 'static/json/city.json', method: 'get' },
    }
    this.api.agent = {
      list: {
        server: 'ucenter/departmentExtend/getAllDepartmentExtendPageList.json',
        method: 'get',
      }, // 获取部门拓展列表
      get: { server: 'ucenter/departmentExtend/getMallBasicInformation.json', method: 'get' }, //获取单个
      add: { server: 'ucenter/departmentExtend/updateMallBasicInformation.json' }, //修改商场基本信息

      brandList: { server: 'api/ucenter/departmentExtend/getAllMallBrandList.json', method: 'get' }, //获取商场人员品牌品类
      getMarketBrandCategoryConfigureList: {
        server: 'api/ucenter/brandCategory/getMarketBrandCategoryConfigureList.json',
        method: 'get',
      }, //获取商场人员品牌品类(新)
      addBrand: { server: 'api/ucenter/departmentExtend/addMallBrand.json' }, // 新增商场品牌品类
      updateBrand: { server: 'api/ucenter/departmentExtend/updateMallBrand.json' }, // 修改商场品牌品类
      deleteBrand: { server: 'api/ucenter/departmentExtend/deleteMallBrand.json' }, // 删除

      saveRegion: { server: 'api/ucenter/brandRegion/updateRegionsToBrand.json' }, // 为指定商场品牌品类添加多个行政区划
      selectRegion: { server: 'api/ucenter/brandRegion/getRegionListToBrand.json', method: 'get' }, // 根据商场品牌品类ID获取行政区划列表
      getRegionConfigureVoList: {
        server: 'api/ucenter/region/getRegionConfigureVoList.json',
        method: 'get',
      }, // 根据pid获取行政区列表
      getRegionConfigureVo: {
        server: 'api/ucenter/region/getRegionConfigureVo.json',
        method: 'get',
      }, // 根据pid获取行政区列表

      addContact: { server: 'api/ucenter/departmentContact/addDepartmentContact.json' }, // 新增----联系人
      deleteContact: { server: 'api/ucenter/departmentContact/softDeleteDepartmentContact.json' }, // 删除----联系人
      editContact: { server: 'api/ucenter/departmentContact/updateDepartmentContact.json' }, // 修改----联系人
      selectContact: {
        server: 'api/ucenter/departmentContact/getAllDepartmentContactList.json',
        method: 'get',
      }, // 查询----联系人

      selectAdmin: { server: 'api/ucenter/departmentExtend/getMallKeeper.json', method: 'get' }, // 查询----管理员
      editAdmin: { server: 'api/ucenter/departmentExtend/updateMallKeeper.json' }, // 修改----管理员
      addAdmin: { server: 'api/ucenter/departmentExtend/addMallKeeper.json' }, // 新增----管理员

      getAgentAllChildrenIdsList: {
        server: 'api/ucenter/departmentExtend/getAgentAllChildrenIdsList.json',
        method: 'get',
      }, // 获取代理商商场下面的部门
    }
    this.api.position = {
      list: { server: 'api/ucenter/position/positionList.json', method: 'get' }, //获取全部
      // tree       : {mock:"/post/tree",        server:""},//获取全部
      children: { server: 'api/ucenter/position/getSubPosition.json', method: 'get' }, //获取全部
      listByDept: { server: 'api/ucenter/position/getPositionByDepartment.json', method: 'get' }, //获取部门所有崗位
      syncToRole: { server: 'api/ucenter/role/addRolesToPositions.json' }, //为所有职位重新生成角色

      add: { server: 'api/ucenter/position/addPosition.json' }, // 职位 —— 新增
      delete: { server: 'api/ucenter/position/softDeletePosition.json' }, // 职位 —— 删除
      update: { server: 'api/ucenter/position/updatePosition.json' }, // 职位 —— 修改

      addAgentPosition: { server: 'api/ucenter/position/addAgentPosition.json' }, // 商场职位 —— 新增
    }
    this.api.user = {
      getCurrent: { server: 'api/ucenter/user/getCurrentUser', method: 'get' }, //获取当前登录用户
      getCurrentLine: {
        baseUrl: process.env.VUE_APP_BASE_PATH,
        server: 'ucenterapi/internal/account/selectOrgBelongMarketClassifyListById',
        method: 'get',
      }, //获取当前登录用户事业线
      list: { server: 'api/ucenter/user/getUserPageList.json' }, //获取全部
      getAgentMaintainAccountPageList: {
        server: 'api/ucenter/user/getAgentMaintainAccountPageList',
      }, //获取经销商用户列表
      get: { server: 'api/ucenter/user/getUser.json', method: 'get' }, //获取单个
      add: { server: 'api/ucenter/user/addUser.json' }, //保存
      update: { server: 'api/ucenter/user/updateUser.json' }, //保存
      setStatus: { server: 'api/ucenter/user/resetUserStatus.json' }, //修改用户状态

      listRole: {
        server: 'api/ucenter/userConfigure/getUserRoleConfigureList.json',
        method: 'get',
      }, //获取角色全部用户
      updateBatchUserRoleConfigureList: {
        server: 'api/ucenter/userConfigure/updateBatchUserRoleConfigureList.json',
      }, //配置用户可管理角色(覆盖)
      insertBatchUserRoleConfigureList: {
        server: 'api/ucenter/userConfigure/insertBatchUserRoleConfigureList.json',
      }, //批量新增用户可管理角色
      deleteUsersToRole: { server: 'api/ucenter/userRole/deleteUsersToRole.json' }, //删除用户信息

      listByPost: { server: 'api/ucenter/userPosition/getUserListToPosition.json', method: 'get' }, //获取部门所有用户
      userEveryDetalMsg: { server: 'api/ucenter/user/getAllMessageListToUser.json', method: 'get' },
      getMarketAdminManagerConfigurePageList: {
        server: 'api/user/marketConfigure/getMarketAdminManagerConfigurePageList.json',
        method: 'get',
      }, //获取用户已配置管理商场列表

      getUserManageLineConfigureTreeList: {
        server: 'api/ucenter/userConfigure/getUserManageLineConfigureTreeList.json',
        method: 'get',
      }, //获取用户已配置管理线别树形列表

      getUserExcelList: {
        server: 'api/ucenter/user/getUserExcelList.json',
        method: 'post',
        responseType: 'blob',
      }, //人员导出（集团）
      getAgentMaintainAccountExcelList: {
        server: 'api/user/export/getAgentMaintainAccountExcelList',
        method: 'post',
        responseType: 'blob',
      }, //人员导出(经销商)

      importOverseasUser: {
        server: 'api/ucenter/userConfigure/mtds/import',
        method: 'post',
        requestType: 'form-data',
      }, //MTDS人员导入
      importOverseasUserLogPageList: {
        server: 'api/ucenter/userConfigure/mtds/importLog/page',
        method: 'post',
      }, //MTDS人员导入日志列表

      /*用户弹框信息展示*/
      saveBrand: { server: 'api/ucenter/userBrand/editBrandToUser.json' },
      //用户可配置线别
      getLineConfigureTreeListToUser: {
        server: 'api/ucenter/userConfigure/getLineConfigureTreeListToUser.json',
        method: 'get',
      }, //获取用户可配置线别列表信息
      editUserToLineList: {
        server: 'api/ucenter/userConfigure/updateBatchUserManageLineConfigureList.json',
      }, //保存用戶配置线别信息
      getLineListToUser: {
        server: 'api/ucenter/userConfigure/getUserManageLineConfigureList.json',
        method: 'get',
      }, //保存用戶配置线别信息
      //用户可配置部门
      getDepartmentConfigureTreeListToUser: {
        server: 'api/ucenter/userConfigure/getDepartmentConfigureTreeListToUser.json',
        method: 'get',
      }, //获取用户可配置管理部门列表
      getDepartmentListToUser: {
        server: 'api/ucenter/userConfigure/getUserManageDepartmentOrMarketConfigureList.json',
        method: 'get',
      }, //获取用户已配置管理部门或管理商场列表
      editUserToDepartmentList: {
        server:
          'api/ucenter/userConfigure/updateBatchUserManageDepartmentOrMarketConfigureList.json',
      }, //修改用户已配置管理部门或商场列表
      //用户可配置品牌品类
      getBrandConfigureListToUser: {
        server: 'api/ucenter/userConfigure/getBrandConfigureListToUser.json',
        method: 'get',
      }, //获取用户可配置品牌品类列表
      getUserBrandConfigureList: {
        server: 'api/ucenter/userConfigure/getUserBrandConfigureList.json',
        method: 'get',
      }, //获取用户已配置品牌品类列表
      updateBatchUserBrandConfigureList: {
        server: 'api/ucenter/userConfigure/updateBatchUserBrandConfigureList.json',
      }, //批量修改用户已配置品牌品类列表
      insertBatchUserBrandConfigureList: {
        server: 'api/ucenter/userConfigure/insertBatchUserBrandConfigureList.json',
      }, //批量新增用户已配置品牌品类列表
      //用户可配置角色
      getRoleConfigurePageListToUser: {
        server: 'api/ucenter/userConfigure/getRoleConfigurePageListToUser.json',
        method: 'get',
      }, //修改用户已配置品牌品类列表
      getUserChannelList: {
        server: 'api/ucenter/userConfigure/getUserChannelConfigureList.json',
        method: 'get',
      }, //用户管理 - 获取用户已配置的所有销售渠道
      getUserChannelConfigureListToUser: {
        server: 'api/ucenter/userConfigure/getUserChannelConfigureListToUser.json',
        method: 'get',
      }, //用户管理 - 获取用户可配置的所有销售渠道
      updateBatchUserChannelConfigureList: {
        server: 'api/ucenter/userConfigure/updateBatchUserChannelConfigureList.json',
      }, //批量修改用户销售渠道
      getAccountLabelConfigureListToAccount: {
        server: 'api/ucenter/userConfigure/getAccountLabelConfigureListToAccount',
        method: 'get',
      }, //获取账号可配置账号标签列表
      getAccountLabelConfigureList: {
        server: 'api/ucenter/userConfigure/getAccountLabelConfigureList',
        method: 'get',
      }, //获取账号已配置账号标签列表
      updateBatchAccountLabelConfigureList: {
        server: 'api/ucenter/userConfigure/batchUpdateAccountLabelConfigureList',
      }, //批量修改账号标签列表
      insertBatchAccountLabelConfigureList: {
        server: 'api/ucenter/userConfigure/batchAddAccountLabelConfigureList',
      }, //批量新增账号标签列表
    }
    this.api.menu = {
      //menu的mock数据在access里面
      listByUser: { server: 'api/ucenter/menu/getMenusToUser.json', method: 'get' }, //获取用户所有菜单功能
      list: { server: 'api/ucenter/menu/getAllMenuList.json', method: 'get' }, //获取全部
      tree: { server: 'api/ucenter/menu/getAllMenuListToTree.json', method: 'get' }, //获取全部
      add: { server: 'api/ucenter/menu/addMenu.json' }, //保存
      update: { server: 'api/ucenter/menu/updateMenu.json' }, //保存
      delete: { server: 'api/ucenter/menu/deleteMenu.json' }, //删除
      relation: { server: 'api/ucenter/menuPermission/getPositionListToMenu.json', method: 'get' }, //获取某功能关联的权限
      setRelation: { server: 'api/ucenter/menuPermission/updatePermissionsToMenu.json' }, //获取某功能关联的权限
      listByRole: { server: 'api/ucenter/menu/getMenusToRole.json', method: 'get' }, //获取某角色下的所有菜单功能
      editByRole: { server: 'api/ucenter/roleMenu/updateMenusToRole.json' }, //获取某角色下的所有菜单功能
      menuRangeModify: { server: 'menuRange/modify.json', method: 'post' }, // 修改菜单使用范围
      menuRangeQueryList: { server: 'menuRange/queryList.json', method: 'get' }, // 查询菜单的使用范围
      roleQueryList: { server: 'api/ucenter/role/listRoleByMenuId', method: 'get' }, // 根据菜单id获取角色列表
      listMenuOfFilterRangeByAccount: {
        baseUrl: process.env.VUE_APP_BASE_PATH,
        server: 'ucenterapi/internal/menu/listMenuOfFilterRangeByAccount',
        method: 'post',
      }, // 根据账号和系统查询经过适用范围过滤的完整菜单树
      sourceRoleListByUserMenu: {
        server: 'api/ucenter/menu/getUserMenuSourceRoleList.json',
        method: 'get',
      }, // 根据用户和菜单查询权限来源角色
    }
    this.api.access = {
      getDictPowerPlatformListToUser: {
        mock: '/access/list',
        server: 'api/ucenter/dictConfigure/getDictPowerPlatformListToUser.json',
        method: 'get',
      }, //获取用户关于权限可配置的系统菜单
      list: { server: 'api/ucenter/permission/getAllPermissionList.json', method: 'get' }, //获取全部
      tree: { server: 'api/ucenter/permission/getAllPermissionListToTree.json', method: 'get' }, //获取全部
      add: { server: 'api/ucenter/permission/addPermission.json' }, //保存
      update: { server: 'api/ucenter/permission/updatePermission.json' }, //保存
      delete: { server: 'api/ucenter/permission/softDeletePermission.json' }, //删除
      // listByUser : {mock:"/access/listByUser",server:""}, //获取用户所有权限 //这个不用前端管
    }
    this.api.role = {
      list: { server: 'api/ucenter/role/getRolePageList.json', method: 'get' }, //获取全部
      get: { server: 'api/ucenter/role/getRole.json', method: 'get' }, //获取单个
      add: { server: 'api/ucenter/role/addRole.json' }, //保存
      update: { server: 'api/ucenter/role/updateRole.json' }, //保存
      softDelete: { server: 'api/ucenter/role/softDeleteRole.json' }, //软删除
      listUser: { server: 'api/ucenter/userRole/getUserListToRole.json', method: 'get' }, //获取角色全部用户
      addUser: { server: 'api/ucenter/userRole/addUsersToRole.json' }, //为指定角色添加多用户
      listChild: {
        server: 'api/ucenter/roleManagerialRoles/getManagerialRolesListToRole.json',
        method: 'get',
      }, //获取角色全部用户
      editChild: { server: 'api/ucenter/roleManagerialRoles/saveManagerialRolesToRole.json' }, //为指定角色添加多用户
      objectList: { server: 'api/ucenter/dataObject/getDataObjectList.json', method: 'get' }, //获取对象实例列表
      saveObj: { server: 'api/ucenter/dataObjectRole/save.json' }, //保存角色对象列表
      userObjList: {
        server: 'api/ucenter/dataObjectRole/getDataObjectRoleList.json',
        method: 'get',
      }, //获取角色 - 对象列表
      getListRole: {
        server: 'api/ucenter/dataObjectRole/getDateObjectListByRole.json',
        method: 'get',
      }, //通过角色ID 获取 角色对象实例
      ohterRole: { server: 'api/ucenter/role/getOtherRoleList.json', method: 'get' }, //获取配发服务商角色
      ExportExcel: { server: 'api/ucenter/role/getListForRoleUserExportExcel.json', method: 'get' }, //获取配发服务商角色

      getRoleManagerialHierarchyConfigureTreeList: {
        server: 'api/ucenter/roleConfigure/getRoleManagerialHierarchyConfigureTreeList.json',
        method: 'get',
      }, //获取角色管理关联层级列表（树形
      insertRoleManagerialHierarchyConfigure: {
        server: 'api/ucenter/roleConfigure/insertRoleManagerialHierarchyConfigure.json',
      }, //新增角色管理关联层级
      softDeleteRoleManagerialHierarchyConfigure: {
        server: 'api/ucenter/roleConfigure/softDeleteRoleManagerialHierarchyConfigure.json',
      }, //删除角色管理关联层级
      updateBatchRoleManagerialRoleConfigureList: {
        server: 'api/ucenter/roleConfigure/updateBatchRoleManagerialRoleConfigureList.json',
      }, //批量修改角色管理角色列表
      getRoleManagerialRoleHierarchyConfigureList: {
        server: 'api/ucenter/roleConfigure/getRoleManagerialRoleHierarchyConfigureList.json',
        method: 'get',
      }, //获取角色已配置管理角色关联层级列表
      getRoleManagerialRoleHierarchyConfigureTreeList: {
        server: 'api/ucenter/roleConfigure/getRoleManagerialRoleHierarchyConfigureTreeList.json',
        method: 'get',
      }, //获取角色已配置管理角色关联层级列表（树形）
      listPositionTypes: {
        server: 'api/ucenter/positionType/list',
        method: 'get',
      }, //岗位类型权威主数据
      getPositionTypesByRole: {
        server: 'api/ucenter/v1/roles/position-types',
        method: 'get',
      }, //通过角色查询关联岗位类型
      getPositionsByRole: {
        server: 'api/ucenter/v1/roles/positions',
        method: 'get',
      }, //通过角色分页查询具体岗位
      listPositionPage: {
        server: 'api/ucenter/v1/positions/page',
        method: 'get',
      }, //通用岗位分页查询（岗位类型/名称/部门筛选）
      savePositionTypes: {
        server: 'api/ucenter/v1/roles/position-types/save',
      }, //全量保存角色关联岗位类型规则
      getPositionAuthPage: {
        server: 'api/ucenter/v1/position-auth/page',
        method: 'get',
      }, //集团岗位权限管理-岗位分页（按管理部门数据范围过滤）
      getPositionRoles: {
        server: 'api/ucenter/v1/position-auth/roles',
        method: 'get',
      }, //查询岗位关联角色（岗位类型规则）
      savePositionRoles: {
        server: 'api/ucenter/v1/position-auth/roles/save',
      }, //全量保存岗位关联角色
    }
    this.api.dict = {
      // tree: { server: "api/ucenter/dict/getAllDictListToTree.json",method:'get'}, //获取全部
      getDictById: { server: 'api/ucenter/dict/getDict', method: 'get' }, //获取全部
      tree: { server: 'api/ucenter/dict/getDictTreeList', method: 'get' }, //获取全部
      // delete: {mock: "/dict/delete", server: "api/ucenter/dict/delete.json"}, //软删除
      delete: { mock: '/dict/delete', server: 'api/ucenter/dict/deleteDictInfo' }, //软删除
      // save: {mock: "/dict/save", server: "api/ucenter/dict/save.json"}, //保存
      addDict: { server: 'api/ucenter/dict/addDictInfo' }, //新增字典
      updateDict: { server: 'api/ucenter/dict/updateDictInfo' }, //修改字典
      getDitTypeListByDitTypes: { server: 'api/ucenter/dict/getDictMapByTypeList', method: 'post' }, //根据 字典类型列表 获取字典信息哈希
      //批量新增或修改字典国际化配置
      updateDictLocaleBatch: {
        server: 'api/ucenter/dict/updateDictLocaleBatch',
        method: 'post',
      },
      //获取字典国际化配置列表
      getDictLocaleListByDictId: {
        server: 'api/ucenter/dict/getDictLocaleListByDictId',
        method: 'get',
      },
      //新增字典国际化配置
      addDictLocale: {
        server: 'api/ucenter/dict/addDictLocale',
        method: 'post',
      },
      //跟新字典国际化配置
      updateDictLocale: {
        server: 'api/ucenter/dict/updateDictLocale',
        method: 'post',
      },
      //删除字典国际化配置
      deleteDictLocale: {
        server: 'api/ucenter/dict/deleteDictLocale',
        method: 'delete',
      },
      select: { server: 'api/ucenter/role/getSystemTypeListByUser.json', method: 'get' }, //查询单类字典值 这个接口有问题
      // getProductChannelList: { server: "api/ucenter/dict/getProductChannelList.json", method: 'get' }, // 产品渠道字典
      getDictListByParentId: { server: 'api/ucenter/dict/getDictListByParentId', method: 'get' }, // 根据 上级ID 获取字典信息列表
      getDictBrandHierarchyConfigureList: {
        server: 'api/ucenter/dictConfigure/getDictBrandHierarchyConfigureList.json',
        method: 'get',
      }, // 获取所有品牌品类组合
      getDictDataConfigConfigurePageList: {
        server: 'api/ucenter/dictConfigure/getDictDataConfigConfigurePageList.json',
        method: 'get',
      }, // 获取字典业务数据配置列表
      addDictDataConfigConfigure: {
        server: 'api/ucenter/dictConfigure/addDictDataConfigConfigure.json',
        method: 'post',
      }, // 新增字典业务数据配置
      updateDictDataConfigConfigure: {
        server: 'api/ucenter/dictConfigure/updateDictDataConfigConfigure.json',
        method: 'post',
      }, // 获取字典业务数据配置列表
      deleteDictDataConfigConfigure: {
        server: 'api/ucenter/dictConfigure/deleteDictDataConfigConfigure.json',
        method: 'post',
      }, // 获取字典业务数据配置列表
      selectDictExtendListByType: {
        baseUrl: process.env.VUE_APP_BASE_PATH,
        server: 'ucenterapi/internal/dict/selectDictExtendListByType',
        method: 'post',
      }, // 获取字典扩展信息列表
    }
    this.api.line = {
      select: { server: 'api/ucenter/line/getLineTreeList', method: 'get' }, // 查询整个线别树
      getLineConfigureTreeList: {
        server: 'api/ucenter/lineConfigure/getLineConfigureTreeList.json',
        method: 'get',
      }, // 经营品类下所属事业线的线别树
      addLine: { mock: '/line/addLine', server: 'api/ucenter/line/addLineInfo' }, // 新增
      oneLine: { server: 'api/ucenter/line/getLineInfo', method: 'get' }, // 修改
      getLineInfoById: {
        baseUrl: process.env.VUE_APP_BASE_PATH,
        server: 'ucenterapi/internal/department/selectDepartmentById',
        method: 'get',
      }, // 根据 部门ID 获取部门信息
      getAccLineInfoById: {
        baseUrl: process.env.VUE_APP_BASE_PATH,
        server: 'ucenterapi/internal/accDepartment/selectDepartmentById',
        method: 'get',
      },
      relevance: { server: 'api/ucenter/lineConfigure/editLineToRegionList.json' }, // 修改线别已配置行政区划列表
      // relevance: {mock: "/line/relevance", server: "api/ucenter/lineRegion/updateRegionsToLine.json"}, // 关联
      updateLine: { mock: '/line/updateLine', server: 'api/ucenter/line/updateLineInfo' }, // 修改
      resetLine: { mock: '/line/updateLine', server: 'api/ucenter/line/resetLineInfo' }, // 调动
      softDeleteLine: { server: 'api/ucenter/line/deleteLineInfo' }, // 删除
      lineRegion: {
        mock: '/line/lineRegion',
        server: 'api/ucenter/lineConfigure/getRegionListToLine.json',
        method: 'get',
      }, // 修改
    }
    this.api.businessObj = {
      schemaList: {
        mock: '/businessObj/schemaList',
        server: 'api/ucenter/dataSchema/getDataSchemaList.json',
        method: 'get',
      }, // 获取数据库列表
      save: { mock: '/businessObj/save', server: 'api/ucenter/dataSchema/save.json' }, //保存数据库
      getTableList: { server: 'api/ucenter/dataSchema/getTableListByName.json', method: 'get' }, //获取表数据
      getColumnList: { server: 'api/ucenter/dataSchema/getColumnListByTable.json', method: 'get' }, //获取字段数据
      delete: { server: 'api/ucenter/dataSchema/delete.json' }, //删除数据库列表
      resouList: {
        server: 'api/ucenter/dataResourceDimension/getDataResourceDimensionList.json',
        method: 'get',
      }, //获取资源维度列表数据
      resource: {
        server: 'api/ucenter/dataResourceDimension/getDataResourceDimension.json',
        method: 'get',
      }, //获取资源维度详情
      deleteDimens: { server: 'api/ucenter/dataResourceDimension/delete.json' }, //删除资源维度
      deletePermi: { server: 'api/ucenter/dataDimension/delete.json' }, //删除权限维度
      saveDimens: { server: 'api/ucenter/dataResourceDimension/saveExpression.json' }, //保存资源维度关联数据
      dimensions: { server: 'api/ucenter/dataDimension/getDataDimensions.json', method: 'get' }, //根据id串获取维度关系数据
      resourceDetal: { server: 'api/ucenter/dataResource/getDataResource.json', method: 'get' }, //根据id获取资源详情信息
    }
    this.api.communication = {
      //商场帐号信息
      saveMarketAccountInfo: { server: 'api/user/marketExtend/saveMarketAccountInfo.json' }, //商场帐号信息--保存
      getMarketAccountInfo: {
        server: 'api/user/marketExtend/getMarketAccountInfo.json',
        method: 'get',
      }, //商场帐号信息--查询
      deleteMarketAccountInfo: { server: 'api/user/marketExtend/deleteMarketAccountInfo.json' }, //商场帐号信息--删除
      getMarketLegalPerson: {
        server: 'api/user/marketExtend/getMarketLegalPerson.json',
        method: 'get',
      }, //商场基本信息 - 检测身份证是否存在

      //商场人员信息
      saveMarketPersonInfo: { server: 'api/user/marketExtend/saveMarketPersonInfo.json' }, //商场人员信息--保存
      deleteMarketPersonInfo: { server: 'api/user/marketExtend/deleteMarketPersonInfo.json' }, //商场人员信息--删除
      getMarketPersonInfo: {
        server: 'api/user/marketExtend/getMarketPersonInfo.json',
        method: 'get',
      }, //商场人员信息--获取
      getMarketPersonAllPosition: {
        server: 'api/user/marketExtend/getMarketPersonAllPosition.json',
        method: 'get',
      }, //商场人员信息--获取商场所有职位
      saveMarketPersonPosition: { server: 'api/user/marketExtend/saveMarketPersonPosition.json' }, //商场人员信息--保存人员职位
      saveMarketPersonRole: { server: 'api/user/marketExtend/saveMarketPersonRole.json' }, //商场人员信息--保存用户角色
      getUserPositionList: {
        server: 'api/user/marketExtend/getUserPositionList.json',
        method: 'get',
      }, //根据用户ID获取职位列表
      getMarketByDepartmentIdToTree: {
        server: 'api/user/marketExtend/getMarketByDepartmentIdToTree.json',
        method: 'get',
      }, //商场人员信息-部门书获取

      //商场店面信息
      saveMarketShopInfo: { server: 'api/user/marketExtend/saveMarketShopInfo.json' }, //商场店面信息--保存
      addMarketShopInfo: { server: 'api/user/marketExtend/addMarketShopInfo.json' }, //新增商场店面信息
      updateMarketShopInfo: { server: 'api/user/marketExtend/updateMarketShopInfo.json' }, //修改商场店面信息
      deleteMarketShopInfo: { server: 'api/user/marketExtend/deleteMarketShopInfo.json' }, //商场店面信息--删除
      getMarketShopInfo: { server: 'api/user/marketExtend/getMarketShopInfo.json', method: 'get' }, //商场店面信息--获取商场门店列表 旧
      getMarketShopInfoPageList: {
        server: 'api/user/marketExtend/getMarketShopInfoPageList.json',
        method: 'get',
      }, //商场门店信息-获取商场门店列表 新
      getMarketShopMappedFictitiousShop: {
        server: 'api/user/marketExtend/getMarketShopMappedFictitiousShop.json',
        method: 'get',
      }, //商场店面信息-根据门店ID获取门店映射的实体门店列表
      getChannelMtdsShopTypeConfigureListToMarket: {
        server: 'api/user/marketConfigure/getChannelMtdsShopTypeConfigureListToMarket.json',
        method: 'get',
      }, //根据渠道获取店面性质
      // batchUpdateShopSimpleName: { server: "api/user/marketExtend/batchUpdateShopSimpleName.json"}, //商场区域名称修改

      //商场经营品类信息
      getMarketBrandCategory: {
        server: 'api/user/marketExtend/getMarketBrandCategory.json',
        method: 'get',
      }, //商场经营品类信息--获取
      saveMarketBrandCategory: { server: 'api/user/marketExtend/saveMarketBrandCategory.json' }, //商场经营品类信息--保存
      modifyDepartmentBrandFobiddenStatus: {
        server: 'api/ucenter/departmentBrand/modifyDepartmentBrandFobiddenStatus.json',
      }, //修改品牌品类状态
      updateMarketExtendStatus: {
        server: 'api/ucenter/marketExtentCompositeData/updateMarketExtendStatus.json',
      }, //开启关闭经营品类传单权限接口
      checkAddMarketBrandCategory: {
        server: 'api/user/marketExtend/checkAddMarketBrandCategory.json',
      }, //校验新增商场经品牌品类信息
      addMarketBrandCategory: { server: 'api/user/marketExtend/addMarketBrandCategory.json' }, //商场经营品牌品类信息-新增商场经品牌品类信息
      updateMarketBrandCategory: { server: 'api/user/marketExtend/updateMarketBrandCategory.json' }, //商场经营品牌品类信息-更新商场经营品牌品类信息
      updateMarketBrandCategoryByForbiddenStatus: {
        server: 'api/user/marketExtend/updateMarketBrandCategoryByForbiddenStatus.json',
      }, //修改商场经营品牌品类-业务状态（启用、禁用、淘汰）
      getMarketBrandCategoryBox: {
        server: 'api/user/marketExtend/getMarketBrandCategoryBox.json',
        method: 'get',
      }, //商场经营品类下拉框--获取
      getMarketBrandCategoryRegionByLineId: {
        server: 'api/user/marketExtend/getMarketBrandCategoryRegionByLineId.json',
        method: 'get',
      }, //商场经营品类--线别选择区域
      getMarketBrandCategoryRegion: {
        server: 'api/user/marketExtend/getMarketBrandCategoryRegion.json',
        method: 'get',
      }, //商场经营品类--经营区域获取
      getMarketBrandCategoryDepartment: {
        server: 'api/user/marketExtend/getMarketBrandCategoryDepartment.json',
        method: 'get',
      }, //商场经营品类--所属部门获取

      //商场详情维护组织架构树
      getMarketRoleList: { server: 'api/user/marketExtend/getMarketRoleList.json', method: 'get' }, //商场角色--获取
      getMarketLineList: {
        server: 'api/user/marketConfigure/getLineConfigureTreeListToMarket.json',
        method: 'get',
      }, //商场部门树列表--获取
      getMarketLineById: {
        server: 'api/user/marketConfigure/getLineConfigureToMarket.json',
        method: 'get',
      }, //根据线别id获取线别详情数据
      // getMarketInfoPageList: { server: "api/user/marketExtend/getMarketInfoPageList.json",method:'get'}, //商场列表--获取
      getMarketVagueList: {
        server: 'api/user/marketExtend/getMarketVagueList.json',
        method: 'get',
      }, //商场列表--获取

      //商场基本信息
      updateMarketInfo: { server: 'api/user/marketExtend/updateMarketInfo.json' }, //商场基本信息--保存
      updateMarketLegalPerson: { server: 'api/user/market/updateMarketLegalPerson' }, //商场基本信息--更新法人、合伙人信息（经营权全更新）
      getMarketInfo: { server: 'api/user/marketExtend/getMarketInfo.json', method: 'get' }, //商场基本信息--获取
      getDepartmentUserList: {
        server: 'api/user/marketExtend/getDepartmentUserList.json',
        method: 'get',
      }, //商场基本信息--获取部门下人员
      getPidRegionList: { server: 'api/user/marketExtend/getPidRegionList.json', method: 'get' }, //根据行政区划PID获取下级行政区划列表
      getDepartmentByTree: {
        server: 'api/user/marketExtend/getDepartmentByTree.json',
        method: 'get',
      }, //获取部门树
      getUserListByDepartmentId: {
        server: 'api/user/marketExtend/getUserListByDepartmentId.json',
        method: 'get',
      }, //获取部门下人员列表
      getUserPageList: { server: 'api/user/marketExtend/getUserPageList.json', method: 'get' }, //获取人员信息
      getMarketInfoList: { server: 'api/user/marketExtend/getMarketInfoList.json', method: 'get' }, //商场--显示报表
      getShopCount: { server: 'api/user/marketExtend/getShopCount.json', method: 'get' }, //商场--统计列表
      getExistenceMarketInfo: {
        server: 'api/user/marketExtend/getExistenceMarketInfo.json',
        method: 'get',
      }, //新增商场-获取已有商场基本信息
      insertMarketInfo: { server: 'api/user/marketExtend/insertMarketInfo.json' }, //新增商场-新增商场
      getMarketNo: { server: 'api/user/marketExtend/getMarketNo.json', method: 'get' }, //新增商场-组织编码
      getPromotionTypeList: { server: 'api/ucenter/dict/getPromotionTypeList.json', method: 'get' }, // 获取促销类型、订单来源字典接口
      // getDictExtendListByCon: { server: "api/ucenter/dict/getDictExtendListByCon.json", method: 'get' }, // 根据关联属性获取相关字典
      getUploadSignature: {
        server: 'attachment/attachment/ossToken',
        baseUrl: process.env.VUE_APP_BASE_PATH,
        method: 'get',
      }, //获取上传签名
      getOssGlobalId: {
        server: 'unified-numbering/global/id',
        baseUrl: process.env.VUE_APP_BASE_PATH,
        method: 'get',
      }, //获取文件命名唯一id防止重复
      getUserPageListByDepartmentId: {
        server: 'api/user/marketExtend/getUserPageListByDepartmentId.json',
        method: 'get',
      }, //分页获取部门下人员列表
      getChannelConfigurationListToDepartment: {
        server: 'api/ucenter/departmentChannel/getChannelConfigurationListToDepartment.json',
        method: 'get',
      }, //根据部门ID获取渠道配置列表
      getChannelListToDepartment: {
        server: 'api/ucenter/departmentChannel/getChannelListToDepartment.json',
        method: 'get',
      }, //根据部门ID获取已选择的渠道列表
      editDepartmentToChannelList: {
        server: 'api/ucenter/departmentChannel/editDepartmentToChannelList.json',
      }, //根据部门ID保存渠道列表
      getMarketChannelList: {
        server: 'api/user/marketExtend/getMarketChannelList.json',
        method: 'get',
      }, //根据部门ID获取渠道列表
      addMarketChannel: { server: 'api/user/marketExtend/addMarketChannel.json' }, //新增渠道
      deleteMarketChannel: { server: 'api/user/marketExtend/deleteMarketChannel.json' }, //删除渠道
      getMarketChannelByMarketBrandLine: {
        server: 'api/user/marketExtend/getMarketChannelConfigurationList.json',
        method: 'get',
      }, //根据 商场ID 获取商场经营品牌品类所
      getChannelConfigureTreeListToMarket: {
        server: 'api/user/marketConfigure/getChannelConfigureTreeListToMarketClassify.json',
        method: 'get',
      }, //根据事业线获取经营渠道
      getDictChannelHierarchyConfigureTreeList: {
        server: 'api/ucenter/dictConfigure/getDictChannelHierarchyConfigureTreeList.json',
        method: 'get',
      }, //获取全招商渠道
      getCompositeData: {
        server: 'api/ucenter/marketExtentCompositeData/getCompositeData.json',
        method: 'get',
      }, //根据商场id查询商场的扩展组合信息
      modifyCompositeData: {
        server: 'api/ucenter/marketExtentCompositeData/modifyCompositeData.json',
      }, //保存修改扩展信息
      getChannelBrandConfigureListToMarket: {
        server: 'api/user/marketConfigure/getChannelBrandConfigureListToMarket.json',
        method: 'get',
      }, //根据渠道获取关联的品牌品类
      getMarketChannelShopTypeAssociationList: {
        server: 'api/user/marketExtend/getMarketChannelShopTypeAssociationList.json',
        method: 'get',
      }, //商场店面信息-根据商场ID获取商场经营渠道关联店面性质信息列表

      //批量商场维护
      getMarketMaintainPageList: {
        server: 'api/ucenter/marketMaintain/getMarketMaintainPageList.json',
      }, //根据商场id查询商场的扩展组合信息
      getMarketMaintainExcelList: {
        server: 'api/ucenter/marketMaintainExport/getMarketMaintainExcelList.json',
        method: 'get',
      }, //根据商场id查询商场的扩展组合信息
      getMarketMaintainShopExcelList: {
        server: 'api/ucenter/marketMaintainExport/getMarketMaintainShopExcelList.json',
        method: 'get',
      }, //门店导出
      editMarketBrandToMarketBrandBelongMarketClassify: {
        server: 'api/ucenter/marketMaintain/editMarketBrandToMarketBrandBelongMarketClassify.json',
      }, //批量修改商场品牌品类信息
      batchInserOrderAttributes: {
        server: 'api/ucenter/marketMaintain/batchInserOrderAttributes.json',
      }, //批量修改商场品牌品类信息
      batchEditMarketExtendComposite: {
        server: 'api/ucenter/marketMaintain/batchEditMarketExtendComposite.json',
      }, //批量列表批量修改扩展信息
      editMarketAdminManagerToMarketList: {
        server: 'api/ucenter/marketMaintain/editMarketAdminManagerToMarketList.json',
      }, //批量列表批量修改扩展信息
      getMarketClassifyConfigureList: {
        server: 'api/ucenter/dictConfigure/getMarketClassifyConfigureList.json',
        method: 'get',
      }, //获取事业线配置列表
      updateBatchMarketExtendCompositeBySendOrderStatus: {
        server: 'api/ucenter/marketMaintain/updateBatchMarketExtendCompositeBySendOrderStatus.json',
      }, //批量操作传单开关
      updateBatchMarketExtendCompositeByForbiddenStatus: {
        server: 'api/ucenter/marketMaintain/updateBatchMarketExtendCompositeByForbiddenStatus.json',
      }, //批量修改拓展信息启用、禁用、淘汰状态

      getMarketMaintainManageRightDetailPageList: {
        server: 'api/user/marketMaintain/getMarketMaintainManageRightDetailPageList.json',
      }, //获取经营权详情信息列表
      getMarketMaintainManageRightPageList: {
        server: 'api/user/marketMaintain/getMarketMaintainManageRightPageList.json',
      }, //获取经营权信息列表
      getPhysicalShopMaintainManageRightDetailPageList: {
        server: 'api/user/marketMaintain/getPhysicalShopMaintainManageRightDetailPageList.json',
      }, //获取实体门店经营权详情信息列表
      batchUpdateMarketManageRightBusinessStatus: {
        server: 'api/user/marketMaintain/batchUpdateMarketManageRightBusinessStatus.json',
      }, //批量更新经营权经营业务状态信息
      batchUpdateMarketManageRight: {
        server: 'api/user/marketMaintain/batchUpdateMarketManageRight.json',
      }, //批量新增经营权详情信息
      batchAddMarketManageRight: {
        server: 'api/user/marketMaintain/batchAddMarketManageRight.json',
      }, //批量新增经营权信息
      batchAddMarketManageRightDetail: {
        server: 'api/user/marketMaintain/batchAddMarketManageRightDetail.json',
      }, //批量新增经营权信息
      batchAddPhysicalShopMarketManageRightDetail: {
        server: 'api/user/marketMaintain/batchAddPhysicalShopMarketManageRightDetail.json',
      }, //批量新增实体门店经营权详情信息
      batchUpdateMarketManageRightDetail: {
        server: 'api/user/marketMaintain/batchUpdateMarketManageRightDetail.json',
      }, //批量更新经营权详情信息
      batchUpdateRightDetailBusinessStatus: {
        server: 'api/user/marketMaintain/batchUpdateRightDetailBusinessStatus.json',
      }, //批量更新经营权详情经营业务状态信息
      batchAddOrderAttributes: { server: 'api/user/marketMaintain/batchAddOrderAttributes.json' }, //批量更新经营权详情经营业务状态信息
      batchDeleteOrderAttributes: {
        server: 'api/user/marketMaintain/batchDeleteOrderAttributes.json',
      }, //批量删除经营权详情经营业务状态信息
      batchUpdatePhysicalShopClosed: {
        server: 'api/user/marketMaintain/batchUpdatePhysicalShopClosed',
      }, //批量更新实体门店状态信息
      getMarketMaintainManageRightExportList: {
        server: 'api/user/export/getMarketMaintainManageRightExportList.json',
        responseType: 'blob',
      }, //批量導出代理经营权列表
      getMarketMaintainManageRightDetailExportList: {
        server: 'api/user/export/getMarketMaintainManageRightDetailExportList.json',
        responseType: 'blob',
      }, //批量導出代理经营权详情列表
      getPhysicalShopMaintainManageRightDetailExportList: {
        server: 'api/user/export/getPhysicalShopMaintainManageRightDetailExportList.json',
        responseType: 'blob',
      }, //批量導出实体门店列表
      coefficientChangeNotice: {
        server: 'marketManageRight/coefficientChangeNotice',
        method: 'post',
      }, //经营权结算系数变更通知

      // 系统管理员信息
      getAgentSystemAdministrator: {
        server: 'api/user/marketExtend/getAgentSystemAdministrator.json',
        method: 'get',
      }, //获取商场系统管理员信息
      getAgentSystemAdministratorRoleList: {
        server: 'api/user/marketExtend/getAgentSystemAdministratorRoleList.json',
        method: 'get',
      }, //获取商场系统管理员默认配置角色列表
      updateAgentSystemAdministrator: {
        server: 'api/user/marketExtend/updateAgentSystemAdministrator.json',
      }, //修改商场系统管理员配置角色
      getAgentSystemAdministratorResetPasswordRemarksList: {
        server: 'api/user/marketExtend/getAgentSystemAdministratorResetPasswordRemarksList.json',
        method: 'get',
      }, //获取重置商场系统管理员密码备注附件列表
      updateAgentSystemAdministratorResetPassword: {
        server: 'api/user/marketExtend/updateAgentSystemAdministratorResetPassword.json',
      }, //重置商场系统管理员密码
      updateAgentSystemAdministratorResetStatus: {
        server: 'api/user/marketExtend/updateAgentSystemAdministratorResetStatus',
        method: 'post',
      }, //重置商场管理员账号状态
      // 附件相关
      getMarketFileInfoList: {
        server: 'api/user/marketExtend/getMarketFileInfoList.json',
        method: 'get',
      }, // 文件获取接口
      addMarketFileInfo: { server: 'api/user/marketExtend/addMarketFileInfo.json' }, // 文件上传接口
      deleteMarketFileInfo: { server: 'api/user/marketExtend/deleteMarketFileInfo.json' }, // 文件删除接口
      updateFileInfos: { server: 'api/user/mgetFileInfosarketExtend/update.json' }, // 文件更新接口

      // 传单映射关系
      getUserManagerShopList: {
        server: 'api/ucenter/sendOrderMapCfg/getUserManagerShopList.json',
        method: 'get',
      }, //根据用户ID获取可管理的门店
      getIOPFranchiserConfigure: {
        server: 'api/ucenter/sendOrderMapCfg/getIOPFranchiserConfigure.json',
        method: 'get',
      }, //根据品牌品类获取IOP门店信息
      getSendorderMapcfgSearch: {
        server: 'api/ucenter/sendOrderMapCfg/getSendorderMapcfgSearch.json',
        method: 'get',
      }, //传单映射配置列表
      sendOrderMapCfgEdit: { server: 'api/ucenter/sendOrderMapCfg/edit.json' }, //修改传单映射配置
      sendOrderMapCfgDelete: { server: 'api/ucenter/sendOrderMapCfg/delete.json' }, //删除传单映射配置
      sendOrderMapCfgSave: { server: 'api/ucenter/sendOrderMapCfg/save.json' }, //新增传单映射配置
      sendOrderMapCfgGetById: { server: 'api/ucenter/sendOrderMapCfg/getById.json', method: 'get' }, //传单映射配置详情
      //经营区域相关
      getMarketManageAreaPageListByCon: {
        server: 'api/user/marketManageArea/getMarketManageAreaPageListByCon.json',
        method: 'post',
      }, //获取经营区域列表（分页）
      getManageAreaDetail: {
        server: 'api/user/marketManageArea/getManageAreaDetail.json',
        method: 'post',
      }, //经营区域详情
      createManageArea: {
        server: 'api/user/marketManageArea/createManageArea.json',
        method: 'post',
      }, //新增经营区域列表
      modifyManageArea: {
        server: 'api/user/marketManageArea/modifyManageArea.json',
        method: 'post',
      }, //修改经营区域列表
      deleteManageArea: {
        server: 'api/user/marketManageArea/deleteManageArea.json',
        method: 'post',
      }, //删除经营区域列表
      bulkEditMarketLevel: {
        server: 'api/user/marketManageArea/updateMarketRankByIds',
        method: 'post',
      }, //批量修改经营区域

      // 事业线经营范围组
      classifyGroupAreaDetailBatchCreateNewGroup: {
        server: 'api/ucenter/classifyGroupAreaDetail/batchCreateNewGroup',
        method: 'post',
      }, //新增事业线经营范围组
      classifyGroupAreaDetailDelete: {
        server: 'api/ucenter/classifyGroupAreaDetail/delete',
        method: 'post',
      }, //删除事业线经营范围组
      classifyGroupAreaDetailModify: {
        server: 'api/ucenter/classifyGroupAreaDetail/modify',
        method: 'post',
      }, //变更事业线经营范围组（包括新增组，和新增组的详情）
      classifyGroupAreaDetailQuery: {
        server: 'api/ucenter/classifyGroupAreaDetail/query',
        method: 'post',
      }, //查询事业线经营范围
      classifyGroupAreaDetailQueryList: {
        server: 'api/ucenter/classifyGroupAreaDetail/queryList',
        method: 'post',
      }, //查询事业线经营范围-列表
      getChannelBrandConfigureListToMarketClassify: {
        server: 'api/user/marketConfigure/getChannelBrandConfigureListToMarketClassify.json',
        method: 'get',
      }, //事业线经营范围-获取事业线可配置渠道和品牌品类配置组合列表
      // 	经营权管理
      getGroupAreaPage: {
        server: 'api/ucenter/classifyGroupArea/getMarketClassifyManageGroupAreaPageList.json',
      }, // 事业线经营权列表（分页）
      getGroupArea: {
        server: 'api/ucenter/classifyGroupArea/getMarketClassifyManageGroupAreaById.json',
        method: 'get',
      }, // 事业线经营权详情
      batchModifyGroupArea: {
        server: 'api/ucenter/classifyGroupArea/batchUpdateMarketClassifyManageNum.json',
      }, // 批量编辑事业线经营权
      modifyGroupArea: {
        server: 'api/ucenter/classifyGroupArea/updateMarketClassifyManageGroupArea.json',
      }, // 编辑事业线经营权
      exportGetGroupAreaPage: {
        server: 'api/user/export/getGroupAreaPage.json',
        method: 'post',
        responseType: 'blob',
      }, // 事业线经营权列表（分页）导出
      exportGetMarketManageAreaPageListByCon: {
        server: 'api/user/export/getMarketManageAreaExportList.json',
        responseType: 'blob',
      }, // 获取经营区域列表（分页）导出
      exportLine: { server: 'api/user/export/line', method: 'post', responseType: 'blob' }, // 线别导出
      getK3ApprovalPageListByCon: { server: 'api/ucenter/k3Operate/getK3ApprovalPageListByCon' }, // 获取经营权K3编码审批列表
      resetInitiationCustomerMasterK3: {
        server: 'api/ucenter/k3Operate/resetInitiationCustomerMasterK3',
      }, // 	根据 批次号 重新发起经营权K3编码

      transferMarketRightApply: { server: 'api/ucenter/transferMarketRight/apply' }, // 	转移经营权
      transferMarketRightQueryPage: { server: 'api/ucenter/transferMarketRight/queryPage' }, // 	转移经营权列表
      sendMsgAgain: { server: 'api/ucenter/transferMarketRight/resendSms' }, // 	重发短信
      updateMarketManageRightLegalPerson: {
        server: 'api/user/market/updateMarketManageRightLegalPerson',
      }, // 	批量修改法人
      selectOrgMarketManageRightListByOrgId: {
        baseUrl: process.env.VUE_APP_BASE_PATH,
        server: 'ucenterapi/internal/org/selectOrgMarketManageRightListByOrgId',
        method: 'get',
      }, // 	根据 商场ID 获取商场代理经营权信息列表

      getOrderAttributeConfigureListToMarket: {
        server: 'api/user/marketConfigure/getOrderAttributeConfigureListToMarket.json',
        method: 'GET',
      }, //商场配置-获取商场可配置下单属性列表
      //新商场相关
      addMarketInfo: { server: 'api/user/market/addMarketInfo.json' }, //新增商场
      addMarketInfoV2: { server: 'api/user/market/addMarketInfoV2.json' }, //新增商场
      checkMarketByLegalPersonRepeatToMarket: {
        server: 'api/user/marketConfigure/checkMarketByLegalPersonRepeatToMarket.json',
        method: 'GET',
      }, //新增商场-检查是否重复
      updateMarketInfo: { server: 'api/user/market/updateMarketInfo.json' }, //商场管理-更新商场 基本信息
      getMarketManagerUserConfigurePageListToMarket: {
        server: 'api/user/marketConfigure/getMarketManagerUserConfigurePageListToMarket.json',
        method: 'get',
      }, //获取商场管理员
      getMarketInfoPageListByCon: {
        server: 'api/user/market/getMarketInfoPageListByCon.json',
        method: 'get',
      }, //商场管理-获取信息列表（分页
      getMarketInfoDetail: { server: 'api/user/market/getMarketInfoDetail.json', method: 'get' }, //商场管理-获取信息列表（分页
      getMarketManageRightInfoList: {
        server: 'api/user/market/getMarketManageRightInfoList.json',
        method: 'get',
      }, //获取经营权信息列表
      getMarketManageRightLogList: {
        server: 'log/queryLogByBizNo',
        method: 'get',
      },
      updateMarketManageRightInfo: { server: 'api/user/market/updateMarketManageRightInfo.json' }, //商场管理-更新经营权信息
      updateMarketManageRightDetailInfo: {
        server: 'api/user/market/updateMarketManageRightDetailInfo.json',
      }, //商场管理-更新经营权信息
      updateMarketManageRightBusinessStatusInfo: {
        server: 'api/user/market/updateMarketManageRightBusinessStatusInfo.json',
      }, //商场管理-更新经营权业务状态信息
      getMarketManageRightDetailInfoList: {
        server: 'api/user/market/getMarketManageRightDetailInfoList.json',
        method: 'get',
      }, //商场管理-获取经营权详情信息列表
      updateMarketManageRightDetailSendOrderStatus: {
        server: 'api/user/market/updateMarketManageRightBusinessStatusInfo.json',
      }, //商场管理-更新经营权详情下单权限信息
      companyInfo: { server: 'api/user/shumai/page/companyInfo' }, // 数脉企业信息查询（分页）
      physicalShopCreate: { server: 'api/ucenter/physicalShop/create' }, //实体门店--新增实体门店
      physicalShopUpdate: { server: 'api/ucenter/physicalShop/update' }, //实体门店--更新实体门店
      physicalShopQueryPage: { server: 'api/ucenter/physicalShop/queryPage' }, //实体门店--分页查询实体门店
      updateSimpleName: { server: 'api/ucenter/physicalShop/updateSimpleName' }, //实体门店--批量维护实体门店的区域简称
      physicalShopView: { server: 'api/ucenter/physicalShop/view', method: 'get' }, //实体门店--查看实体门店
      physicalShopUpdateStatus: { server: 'api/ucenter/physicalShop/updateStatus', method: 'get' }, //实体门店--修改状态
      queryListForTransferShopRight: { server: 'api/user/market/queryListForTransferShopRight' }, //商场管理--查询用于转移门店经营权所用的列表
      physicalShopDelete: { server: 'api/ucenter/physicalShop/delete', method: 'get' }, //实体门店--删除实体门店
      transferRight: { server: 'api/ucenter/physicalShop/transferRight' }, //实体门店--转移经营权
      locationNeighbor: { server: 'api/ucenter/physicalShop/locationNeighbor' }, //实体门店--定位附近的实体门店

      // 大商管理相关

      checkMarketJoinAgentGroupToMarket: {
        server: 'api/user/marketConfigure/checkMarketJoinAgentGroupToMarket',
        method: 'get',
      }, //校验商场淘汰时是否加入大商组织
      getMarketAgentGroupPageList: {
        server: 'api/user/marketAgentGroup/getMarketAgentGroupPageList',
      }, //获取商场组列表（分页）
      getMarketAgentGroupDetailPageList: {
        server: 'api/user/marketAgentGroup/getMarketAgentGroupDetailPageList',
      }, //获取商场组详情列表（分页）
      getMarketAgentGroupApproveHistoryPageList: {
        server: 'api/user/marketAgentGroup/getMarketAgentGroupApproveHistoryPageList',
      }, //获取商场组申请列表（分页）
      batchUpdateMarketManageRightInfo: {
        method: 'post',
        server: 'api/user/market/updateMarketManageRightInfo',
        requestType: 'form-data',
      }, //batchUpdateMarketManageRightInfo 批量导入
      matchK3CustomerChannel: {
        method: 'post',
        server: 'api/user/market/matchK3CustomerChannel',
      }, //匹配客户类别
      getMarketAgentGroupDetailExportList: {
        server: 'api/user/export/getMarketAgentGroupDetailExportList',
        method: 'post',
        responseType: 'blob',
      }, //导出商场组信息列表

      //法人分页查询数据
      dealerPageFindByCriteria: {
        baseUrl: process.env.VUE_APP_BASE_PATH,
        // server: 'investment/dealer/pageFindByCriteria',
        server: 'investment/dealer/pageFindByCriteriaNoAuth', // 无授权接口
        method: 'post',
      },
      //法人详情
      dealerDetail: {
        baseUrl: process.env.VUE_APP_BASE_PATH,
        server: 'investment/dealer/detail',
        method: 'get',
      },
    }
    this.api.desigSoft = {
      login: { server: process.env.desigSoftloginPath },
    }

    // 关联商场
    this.api.relevanceMarket = {
      saveRelevanceMarket: { server: 'api/ucenter/departmentRelation/save.json' }, // 保存关联商场
      deleteRelevanceMarket: { server: 'api/ucenter/departmentRelation/delete.json' }, // 删除关联商场
      getRelevanceMarketList: {
        server: 'api/ucenter/departmentRelation/getList.json',
        method: 'get',
      }, // 获取关联商场列表
      getDepartmentRelationInfo: {
        server: 'api/ucenter/departmentRelation/getDepartmentRelationInfo.json',
        method: 'get',
      }, // 获取配置详情
      getMarketListSearch: {
        server: 'api/user/marketConfigure/getMarketConfigureList.json',
        method: 'get',
      }, // 获取商场
    }
    // 工作流
    this.api.flowCenter = {
      //流程相关
      pageFindActiveByESAndAuth: {
        baseUrl: process.env.VUE_APP_BASE_PATH,
        server: 'workflow/processInstance/pageFindActiveByESAndAuth',
        method: 'post',
      },
      getTaskDetail: {
        baseUrl: process.env.VUE_APP_BASE_PATH,
        server: 'workflow/task',
        method: 'get',
      },
      getReadDetailById: {
        baseUrl: process.env.VUE_APP_BASE_PATH,
        server: 'workflow/task/toReadTask/detail',
        method: 'get',
      },
      processInstanceNotAuthExport: {
        baseUrl: process.env.VUE_APP_BASE_PATH,
        server: 'workflow/processInstance/v2/notAuth/export',
        method: 'post',
        responseType: 'blob',
      },
    }
    this.api.config = {
      //基础数据配置相关
      //渠道相关
      getChannelConfigurePageList: {
        server: 'api/ucenter/channel/getChannelInfoPageList',
        method: 'get',
      },
      addChannelConfigure: { server: 'api/ucenter/channel/addChannelInfo' },
      updateChannelConfigure: { server: 'api/ucenter/channel/updateChannelInfo' },
      deleteChannelConfigure: { server: 'api/ucenter/channel/deleteChannelInfo' },
      // 获取字典关联属性列表 (配置专用)
      getDictExtendConfigurePageList: {
        server: 'api/ucenter/dictConfigure/getDictExtendConfigurePageList.json',
        method: 'get',
      },
      // 新增字典关联属性
      addDictExtendConfigureList: {
        server: 'api/ucenter/dictConfigure/addDictExtendConfigureList.json',
      },
      // 删除字典关联属性
      deleteDictExtendConfigure: {
        server: 'api/ucenter/dictConfigure/deleteDictExtendConfigure.json',
      },
      // 获取字典关联属性配置项
      getDictExtendConfigureItemList: {
        server: 'api/ucenter/dictConfigure/getDictExtendConfigureItemList.json',
        method: 'get',
      },
      //配置系统管理权限
      getDictPowerConfigurePageList: {
        server: 'api/ucenter/dictConfigure/getDictPowerConfigurePageList.json',
        method: 'get',
      },
      getUserConfigurePageListToDictPowerPlatform: {
        server: 'api/ucenter/dictConfigure/getUserConfigurePageListToDictPowerPlatform.json',
        method: 'get',
      },
      addUserListToDictPowerPlatform: {
        server: 'api/ucenter/dictConfigure/addUserListToDictPowerPlatform.json',
      },
      deleteUserListToDictPowerPlatform: {
        server: 'api/ucenter/dictConfigure/deleteUserListToDictPowerPlatform.json',
      },
      //字典层级关系相关
      getDictHierarchyConfigureTreeList: {
        server: 'api/ucenter/dictConfigure/getDictHierarchyConfigureTreeList.json',
        method: 'get',
      },
      addDictHierarchyConfigure: {
        server: 'api/ucenter/dictConfigure/addDictHierarchyConfigure.json',
      },
      softDeleteDictHierarchyConfigure: {
        server: 'api/ucenter/dictConfigure/softDeleteDictHierarchyConfigure.json',
      },
      updateDictHierarchyConfigure: {
        server: 'api/ucenter/dictConfigure/updateDictHierarchyConfigure.json',
      },
      //国家编码相关
      updateRegionCountry: { server: 'api/ucenter/region/updateRegionCountry.json' }, //修改行政区划-国家信息
      getRegionCountryContinentsList: {
        server: 'api/ucenter/region/getRegionCountryContinentsList.json',
        method: 'get',
      }, //获取行政区划-7大洲信息列表
      getRegionCountryPageListByCon: {
        server: 'api/ucenter/region/getRegionCountryPageListByCon.json',
        method: 'get',
      }, //获取行政区划-国家信息列表
      getRegionCountryExcelList: {
        server: 'api/ucenter/region/getRegionCountryExcelList.json',
        method: 'get',
      }, //导出行政区划-国家信息列表
      getRegionOverseasCityTreeList: {
        server: 'api/ucenter/region/getRegionOverseasCityTreeList.json',
        method: 'get',
      }, //获取国家下的城市列表（树形结构）
      insertRegionOverseasCity: { server: 'api/ucenter/region/insertRegionOverseasCity.json' }, //新增行政区划-海外城市信息
      updateRegionOverseasCity: { server: 'api/ucenter/region/updateRegionOverseasCity.json' }, //修改行政区划-海外城市信息
      deleteRegionOverseasCity: { server: 'api/ucenter/region/deleteRegionOverseasCity.json' }, //删除行政区划-海外城市信息）
      // 商场招商区域配置
      getMarketInvestmentAreaPageListByCon: {
        server: 'api/user/marketInvestmentArea/getMarketInvestmentAreaPageListByCon.json',
        method: 'get',
      },
      deleteMarketInvestmentArea: {
        server: 'api/user/marketInvestmentArea/deleteMarketInvestmentArea.json',
      },
      addMarketInvestmentArea: {
        server: 'api/user/marketInvestmentArea/addMarketInvestmentArea.json',
      },
      updateMarketInvestmentArea: {
        server: 'api/user/marketInvestmentArea/updateMarketInvestmentArea.json',
      },
      getMarketInvestmentAreaListByRegexpRegionId: {
        server: 'api/user/marketInvestmentArea/getMarketInvestmentAreaListByRegexpRegionId.json',
        method: 'get',
      },
      getMarketInvestmentArea: {
        server: 'api/user/marketInvestmentArea/getMarketInvestmentArea.json',
        method: 'get',
      },
      getMarketInvestmentAreaListBySearchName: {
        server: 'api/user/marketInvestmentArea/getMarketInvestmentAreaListBySearchName.json',
        method: 'get',
      },
      updateDictExtend: {
        server: 'api/ucenter/dictConfigure/updateDictExtendConfigureList.json',
        method: 'post',
      },
    }

    this.api.thirdParty = {
      //【数脉】数据接口模糊查询
      companyInfoPage: {
        server: 'api/user/shumai/companyInfoPage',
        method: 'post',
      },
    }
    this.api.sampleInfo = {
      // 根据店面编码查询样品信息列表
      getSampleInfoByShopNo: {
        server: 'assp-portal-eureka/assp/shopSample/v1/getSampleInfoByShopNo',
        method: 'get',
        baseUrl: process.env.VUE_APP_BASE_PATH,
      },
    }
    // 门店管理相关
    this.api.store = storeApi
  }

  /**
   * 格式化api链接
   * @Author BillionChen
   * @param  {Boolean}   isStatic [是否静态api(没有ajax方法的配置链接)]
   * @return {[type]}             [description]
   */
  toUrl(isStatic = undefined) {
    let rs = {}
    for (let v in this.api) {
      rs[v] = {}
      // console.log(isToMock,process.env.MOCK_ON,'查看环境')
      for (let item in this.api[v]) {
        if (this.api[v][item].static !== isStatic) continue //静态链接不纳入api
        if (this.api[v][item]['server']) {
          rs[v][item] = process.env.VUE_APP_BASE_PATH + this.api[v][item]['server']
        }
      }
    }
    return rs
  }
  getUrl(data = {}) {
    if (data && data.server && typeof data.server === 'string') {
      if (data.baseUrl && typeof data.baseUrl === 'string') {
        return `${data.baseUrl}${data.server}`
      } else {
        return `${process.env.VUE_APP_BASE_PATH}ucenter/${data.server}`
      }
    }
  }
  setAxios(config, data, params, query) {
    let configs = { method: 'post' }
    if (config.requestType === 'form') {
      //默认content-type是json格式 如果要要用form-data提交里面需要加参数requestType
      let formatData = urlFormat(data)
      configs.headers = formatData.headers
      data = formatData.data
    }
    if (config.requestType === 'form-data') {
      let formatData = formFormat(data)
      configs.headers = formatData.headers
      data = formatData.data
    }
    if (config.responseType) {
      configs.responseType = config.responseType
    }
    if (config.timeout) {
      configs.timeout = config.timeout
    }
    if (typeof config.method === 'string' && this.methods.includes(config.method.toLowerCase())) {
      configs.method = config.method.toLowerCase()
      if (configs.method === 'get') {
        configs.params = data
      }
      // TODO 很 low 改不动， 临时支持 DELETE query 传参，
      if (params && configs.method === 'delete') {
        configs.params = params
      }
    }
    if (!configs.params) {
      configs.data = data
    }
    if (query && typeof query === 'object' && Object.keys(query).length) {
      configs.params = query
    }
    if (config.responseType) configs.responseType = config.responseType
    configs.url = this.getUrl(config)
    return axios(configs).then(this.checkStatus).then(this.checkJson).then(this.checkError(config))
  }
  request() {
    let rs = {}
    for (let module in this.api) {
      rs[module] = {}
      for (let item in this.api[module]) {
        let itemInfo = this.api[module][item]
        rs[module][item] = (data = {}, params = {}, query = {}) => {
          return this.setAxios(itemInfo, data, params, query)
        }
      }
    }
    return rs
  }
  sentForm(option = {}, data) {
    let url = this.getUrl(option)
    if (!url || (!this.flag && url === this.lastUrl)) {
      return
    }
    this.flag = false
    this.lastUrl = url
    let forms = document.createElement('form')
    forms.setAttribute('style', 'diaplay:none')
    forms.setAttribute('target', '')
    forms.setAttribute('method', option.method || 'post')
    forms.setAttribute('action', url)
    let tBody = document.getElementsByTagName('body')[0]
    tBody.appendChild(forms)
    let creatEleInput = (key, value) => {
      let inputs = document.createElement('input')
      inputs.setAttribute('name', key)
      inputs.setAttribute('value', value)
      forms.appendChild(inputs)
    }
    let params = {
      ...data,
      AppCode: 'OPUC',
      SubAppCode: 'OPUCPC001',
      'Oauth2-AccessToken': getOauth2AccessToken(),
    }
    for (let k in params) {
      if (params[k]) {
        creatEleInput(k, params[k])
      }
    }
    forms.submit()
    setTimeout(() => {
      forms.parentNode.removeChild(forms)
      this.flag = true
    }, 1000)
  }
  readBlobByReader(blob, fileName) {
    const fileReader = new FileReader()
    fileReader.onload = (res) => {
      const { result } = res.target // 得到字符串
      if (result.indexOf('status') !== -1 && result.indexOf('code') !== -1) {
        let jsonData = JSON.parse(result)
        if (jsonData.message) {
          new Vue().$message.error(jsonData.message)
        }
      } else {
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      }
    }
    fileReader.onerror = (res) => {
      new Vue().$message.error('解析文件异常')
      console.log(res, '----')
    }
    fileReader.readAsText(blob, 'utf-8')
  }
  async getFile(itemInfo, params, fileName) {
    let loading = null
    loading = Loading.service({
      body: true,
      background: 'rgba(0, 0, 0, 0.5)',
      text: '正在导出',
    })
    try {
      let res = await this.setAxios({ timeout: 180000, ...itemInfo }, params)
      loading.close()
      if (res.size) {
        this.readBlobByReader(res, fileName)
      }
    } catch (err) {
      loading.close()
      console.log(err, '下载失败')
    }
  }
  export() {
    let rs = {}
    for (let module in this.api) {
      rs[module] = {}
      for (let item in this.api[module]) {
        let itemInfo = this.api[module][item]
        rs[module][item] = (params = {}, fileName = '文件.xlsx') => {
          if (String(itemInfo.method).toLowerCase() === 'get') {
            return this.sentForm(itemInfo, params)
          } else {
            return this.getFile(itemInfo, params, fileName)
          }
        }
      }
    }
    return rs
  }
  checkStatus(response) {
    // debugger
    // 如果 http 状态码正常, 则直接返回数据
    // 异常状态下, 把错误信息返回去
    // 因为前面我们把错误扶正了, 不然像 404, 500 这样的错误是走不到这里的
    // 未登录被302拦截后,没有返回//这里应该有坑的...但暂时是不会出问题的
    if (!response) {
      return {
        status: false,
        code: '500',
        exception: '系统错误，请稍后重试!',
        login: false,
      }
    }

    return [200, 304].indexOf(response.status) !== -1
      ? response.data
      : {
          status: false,
          code: response.status,
          exception: [response.status, response.statusText, response.request.responseURL].join(' '),
        }
  }

  checkJson(data) {
    return (typeof data).toLowerCase() === 'string' ? JSON.parse(data) : data
  }

  checkError(config) {
    return (data) => {
      if (data && (data instanceof Blob || data.status)) {
        return data
      } else {
        console.error(data, typeof data)
        !data &&
          (data = {
            status: false,
            code: '500',
            msg: '服务器异常，请稍后再试！(未知异常)',
          })
        if (
          data &&
          NeedLoginStatus.includes(String(data.code)) &&
          data.data &&
          typeof data.data === 'string' &&
          data.data.indexOf('http') === 0
        ) {
          const authUri = new URL(data.data)
          const currentUri = new URL(window.location.href)
          authUri.searchParams.set('client_redirect_uri', currentUri.toString())
          authUri.searchParams.set('AppCode', 'OPUC')
          authUri.searchParams.set('SubAppCode', 'OPUCPC001')
          window.location = authUri.toString()
          return data
        }

        if (!(data.code === '200' || data.code === '100000')) {
          let msg =
            data.message || data.msg || data.exception || data.errMsg || '系统错误，请稍后重试!'
          let elLoadingMask = document.querySelector('.el-loading-mask.is-fullscreen')
          if (elLoadingMask) {
            elLoadingMask.style.display = 'none'
          }
          data.msg = msg
          new Vue().$message.error({
            title: `服务器异常，请稍后再试！(${msg})`,
            message: msg,
          })
          return data
        }
      }
      if (data && !data.status) {
        return data
      }
    }
  }
}

const apiUrls = new ApiConfig().toUrl()
let apiNames = []
for (let module in apiUrls) {
  for (let item in apiUrls[module]) {
    let name = 'api' + module.toFirstUpperCase() + item.toFirstUpperCase()
    apiNames.push(name)
  }
}

export default apiUrls
export const apiNameList = apiNames
export const staticApi = new ApiConfig().toUrl(false, true)
export const mock = new ApiConfig().toUrl(true)
export const api = new ApiConfig().request()
export const checkError = new ApiConfig().checkError()
export const exportData = new ApiConfig().export()

// Concrete-position authorization endpoints share the existing transport and error contract.
const positionAuthTransport = new ApiConfig()
const positionAuthRequest = (path, method, data = {}) =>
  positionAuthTransport.setAxios({ server: `api/ucenter/v2/${path}`, method }, data)
api.positionAuth = {
  policy: () => positionAuthRequest('position-auth/policy', 'get'),
  tree: () => positionAuthRequest('position-auth/tree', 'get'),
  page: (data) => positionAuthRequest('position-auth/page', 'get', data),
  detail: (data) => positionAuthRequest('position-auth/roles', 'get', data),
  rolePositions: (roleId, data) =>
    positionAuthRequest(`roles/${encodeURIComponent(roleId)}/positions`, 'get', data),
  preview: (data) => positionAuthRequest('position-auth/changes/preview', 'post', data),
  commit: (data) => positionAuthRequest('position-auth/changes/commit', 'post', data),
  change: (id) => positionAuthRequest(`position-auth/changes/${encodeURIComponent(id)}`, 'get'),
  failures: (id, data) =>
    positionAuthRequest(`position-auth/changes/${encodeURIComponent(id)}/failures`, 'get', data),
  retry: (id) =>
    positionAuthRequest(`position-auth/changes/${encodeURIComponent(id)}/retry`, 'post'),
}
